// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { NotificationEvent } from './notification-event';
import { NotificationTemplate } from './notification-template';
import { NotificationType } from './notification-type';
import { NotificationEventEnum } from './enums';
import { NotificationTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class NotificationSendLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String */
  contextJson?: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** Boolean */
  isSuccess!: boolean;
  /** Enum FK notificationEvent */
  notificationEventId!: NotificationEventEnum;
  /** Guid FK notificationTemplate */
  notificationTemplateId?: string;
  /** Enum FK notificationType */
  notificationTypeId!: NotificationTypeEnum;
  /** String(200) */
  recipientAddress?: string;
  /** Guid */
  recipientUserId?: string;
  /** Guid */
  relatedJoHeaderId?: string;
  /** String(500) */
  status?: string;
  /** FK notificationEventId */
  notificationEvent!: NotificationEvent;
  /** FK notificationTemplateId */
  notificationTemplate!: NotificationTemplate;
  /** FK notificationTypeId */
  notificationType!: NotificationType;
}

